import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';
import teTranslation from './locales/te/translation.json'; // Import Telugu translation

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      te: { // Add Telugu resources
        translation: teTranslation
      }
    },
    fallbackLng: 'en', // use en if detected lng is not available
    debug: true,

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;